import { useCallback } from "react";

import { BedType } from "@/lib/gql/__generated__/graphql";

import { BEDS_TYPE } from "@/components/features/items/edit/_shared/constants/beds";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomBedType = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { beds } = viewModel;

	const options = BEDS_TYPE.map((item) => {
		return {
			id: "room_bed_type" + item.key,
			label: item.key,
			value: item.value,
		};
	});

	const appendItem = useCallback(() => {
		const newValue = [
			...beds.value,
			{
				bedType: { isEdited: true, value: BedType.Single },
				bedNum: { isEdited: true, value: 1 },
			},
		];

		onSetViewModel([{ key: "beds", value: { ...beds, value: newValue } }]);
	}, [beds, onSetViewModel]);

	const removeItem = useCallback(
		(index: number) => {
			const newValue = beds.value.filter((_, i) => i !== index);
			onSetViewModel([{ key: "beds", value: { ...beds, value: newValue } }]);
		},
		[beds, onSetViewModel],
	);

	const onSetBedType = useCallback(
		(bedType: BedType, index: number) => {
			const newValue = beds.value.map((bed, i) => {
				if (i === index) {
					return {
						...bed,
						bedType: {
							...bed.bedType,
							value: bedType,
						},
					};
				} else {
					return bed;
				}
			});

			onSetViewModel([{ key: "beds", value: { ...beds, value: newValue } }]);
		},
		[beds, onSetViewModel],
	);

	const onSetBedNum = useCallback(
		(bedNum: number | undefined, index: number) => {
			const newValue = beds.value.map((bed, i) => {
				if (i === index) {
					return {
						...bed,
						bedNum: {
							...bed.bedNum,
							value: bedNum!,
						},
					};
				} else {
					return bed;
				}
			});

			onSetViewModel([{ key: "beds", value: { ...beds, value: newValue } }]);
		},
		[beds, onSetViewModel],
	);

	const isEdited = beds?.isEdited;
	const hasError = beds.hasError;

	return {
		isEdited,
		hasError,

		options,

		beds,
		appendItem,
		removeItem,
		onSetBedType,
		onSetBedNum,
	};
};
